<template>
  <div class="profile-page">
    <van-nav-bar fixed placeholder class="page-nav" :border="false">
      <template #title>
        <span class="page-title">{{ $t('ui.mine.title') }}</span>
      </template>
      <template #right>
        <van-icon name="home-o" class="home-icon" @click="$router.push('/Home')" />
      </template>
    </van-nav-bar>

    <div class="profile-content">
      <section class="profile-hero">
        <div class="hero-top">
          <div class="user-block">
            <div class="avatar-wrap">
              <img src="https://m.sincereloves.online/logo.png" alt="avatar" class="user-avatar">
              <span class="vip-badge">{{ vipLabel }}</span>
            </div>
            <div class="user-meta">
              <div class="user-name">{{ userInfo.username || $t('ui.mine.guest') }}</div>
              <div class="vip-text">{{ vipLabel }}</div>
            </div>
          </div>

          <van-icon name="edit" class="edit-icon" @click="$router.push('/Infomation')" />
        </div>

        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-label">{{ $t('ui.mine.points') }}</div>
            <div class="stat-value notranslate" translate="no">{{ formatMoneyValue(userInfo.money) }}</div>
          </div>
          <div class="stat-item">
            <div class="stat-label">{{ $t('ui.mine.credit_score') }}</div>
            <div class="stat-value notranslate" translate="no">{{ formatIntegerValue(userInfo.xinyu) }}</div>
          </div>
          <div class="stat-item">
            <div class="stat-label">{{ $t('ui.mine.video_views') }}</div>
            <div class="stat-value notranslate" translate="no">{{ videoViews }}</div>
          </div>
        </div>
      </section>

      <section class="vip-banner">
        <div class="vip-title">{{ $t('ui.mine.vip_title') }}</div>
        <div class="vip-desc">{{ $t('ui.mine.vip_desc') }}</div>
      </section>

      <section class="menu-panel">
        <button
          v-for="item in menuItems"
          :key="item.key || item.label"
          class="menu-item"
          @click="handleMenuClick(item)"
        >
          <span class="menu-item__label">
            {{ item.label }}
            <em v-if="item.badge > 0" class="menu-badge">{{ item.badge > 99 ? '99+' : item.badge }}</em>
          </span>
          <van-icon name="arrow" />
        </button>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      scrollbarStyleId: 'mine-scrollbar-style',
      unreadMsgCount: 0
    };
  },
  computed: {
    menuItems() {
      return [
        { key: 'recharge', label: this.$t('ui.mine.menu_recharge'), path: '/Recharge' },
        { key: 'withdraw', label: this.$t('ui.mine.menu_withdraw'), path: '/Withdraw' },
        { key: 'wallet', label: this.$t('ui.mine.menu_wallet'), path: '/BindCard' },
        { key: 'withdraw_record', label: this.$t('ui.mine.menu_withdraw_record'), path: '/WithdrawRecord' },
        { key: 'recharge_record', label: this.$t('ui.mine.menu_recharge_record'), path: '/RechargeList' },
        { key: 'messages', label: this.$t('ui.mine.menu_messages'), path: '/Messages', badge: this.unreadMsgCount },
        { key: 'order_record', label: this.$t('ui.mine.menu_order_record'), path: '/GameRecord' },
        { key: 'logout', label: this.$t('ui.mine.menu_logout'), action: 'logout' }
      ];
    },
    videoViews() {
      return this.formatIntegerValue(
        this.userInfo.watch_num || this.userInfo.video_num || this.userInfo.look_num || 0,
      );
    },
    vipLabel() {
      const raw = String(this.userInfo.vip || '1').trim();
      if (!raw) {
        return 'VIP1';
      }
      if (/^vip/i.test(raw)) {
        return raw.toUpperCase();
      }
      const num = String(raw).replace(/\D+/g, '') || '1';
      return `VIP${num}`;
    }
  },
  methods: {
    formatMoneyValue(value) {
      const numericValue = Number(value);
      if (Number.isFinite(numericValue)) {
        return numericValue.toFixed(2);
      }
      return '0.00';
    },
    formatIntegerValue(value) {
      const numericValue = Number(value);
      if (Number.isFinite(numericValue)) {
        return String(Math.trunc(numericValue));
      }
      return '0';
    },
    handleMenuClick(item) {
      if (item.action === 'logout') {
        const token = localStorage.getItem('token');
        if (token) {
          sessionStorage.removeItem(`login_intro_shown_${token}`);
        }
        localStorage.clear();
        this.$cookies.remove('token');
        this.$router.push('/Login');
        return;
      }

      this.$router.push(item.path);
    },
    hideRootScrollbar() {
      if (typeof document === 'undefined') {
        return;
      }

      const root = document.documentElement;
      const body = document.body;

      root.style.setProperty('scrollbar-width', 'none');
      body.style.setProperty('scrollbar-width', 'none');
      root.style.setProperty('-ms-overflow-style', 'none');
      body.style.setProperty('-ms-overflow-style', 'none');

      if (!document.getElementById(this.scrollbarStyleId)) {
        const style = document.createElement('style');
        style.id = this.scrollbarStyleId;
        style.textContent = `
html::-webkit-scrollbar,
body::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  display: none !important;
}
        `;
        document.head.appendChild(style);
      }
    },
    restoreRootScrollbar() {
      if (typeof document === 'undefined') {
        return;
      }

      const root = document.documentElement;
      const body = document.body;
      const style = document.getElementById(this.scrollbarStyleId);

      root.style.removeProperty('scrollbar-width');
      body.style.removeProperty('scrollbar-width');
      root.style.removeProperty('-ms-overflow-style');
      body.style.removeProperty('-ms-overflow-style');

      if (style && style.parentNode) {
        style.parentNode.removeChild(style);
      }
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data || {};
          if (this.userInfo.status !== 1 && this.userInfo.is_online !== 1) {
            this.$toast(this.$t('video.account_out'));
            localStorage.clear();
            this.$router.push({ path: '/Login' });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    fetchUnreadMsgCount() {
      if (!localStorage.getItem('token')) {
        this.unreadMsgCount = 0;
        return;
      }
      const rootCount = this.$root && typeof this.$root.siteMsgUnreadCount === 'number'
        ? this.$root.siteMsgUnreadCount
        : null;
      if (rootCount !== null) {
        this.unreadMsgCount = rootCount;
      }
      this.$http({
        method: 'get',
        url: 'user_msg_unread'
      }).then((res) => {
        if (res.code === 200 && res.data) {
          this.unreadMsgCount = Number(res.data.count) || 0;
          if (this.$root) {
            this.$root.siteMsgUnreadCount = this.unreadMsgCount;
          }
        }
      });
    }
  },
  mounted() {
    this.hideRootScrollbar();
  },
  beforeDestroy() {
    this.restoreRootScrollbar();
  },
  activated() {
    this.fetchUnreadMsgCount();
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo();
      this.fetchUnreadMsgCount();
      if (this.$root && typeof this.$root.refreshSiteMsgBadge === 'function') {
        this.$root.refreshSiteMsgBadge().then((count) => {
          this.unreadMsgCount = Number(count) || 0;
        });
      }
    } else {
      this.userInfo = {
        username: this.$t('ui.mine.guest'),
        money: '0.00',
        xinyu: '0'
      };
    }
  }
};
</script>

<style lang="less" scoped>
.profile-page {
  min-height: 100vh;
  padding-bottom: 126px;
  background: linear-gradient(180deg, #030d24 0%, #000 42%, #000 100%);
  color: #fff;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.profile-page::-webkit-scrollbar {
  display: none;
}

.page-nav {
  min-height: 98px;
  background: #1c1c1e;
}

::v-deep .page-nav .van-nav-bar {
  background: #1c1c1e;
  box-shadow: none;
}

::v-deep .page-nav .van-nav-bar__content {
  height: 88px;
}

::v-deep .page-nav .van-nav-bar__left,
::v-deep .page-nav .van-nav-bar__right {
  padding: 0 18px;
}

.page-title {
  color: #e6b98a;
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
}

.home-icon {
  color: #e6b98a;
  font-size: 38px;
}

.profile-content {
  min-height: calc(100vh - 170px);
  padding-bottom: 20px;
  background: transparent;
}

.profile-hero {
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(230, 185, 138, 0.18);
  background:
    radial-gradient(circle at top left, rgba(239, 199, 155, 0.18), transparent 34%),
    linear-gradient(180deg, #15233a 0%, #0a1325 100%);
}

.hero-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 18px 16px;
}

.user-block {
  display: flex;
  align-items: center;
}

.avatar-wrap {
  position: relative;
  width: 88px;
  height: 88px;
  flex-shrink: 0;
}

.user-avatar {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  border: 3px solid rgba(239, 199, 155, 0.75);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.28);
  object-fit: cover;
}

.vip-badge {
  position: absolute;
  left: 50%;
  bottom: -6px;
  transform: translateX(-50%);
  min-width: 54px;
  padding: 2px 8px;
  border-radius: 999px;
  background: linear-gradient(90deg, #f0be88, #e7a35d);
  color: #5a2f1d;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.4;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.28);
  white-space: nowrap;
}

.user-meta {
  margin-left: 18px;
  min-width: 0;
}

.user-name {
  color: #f7d2ab;
  font-size: 24px;
  font-weight: 700;
}

.vip-text {
  margin-top: 6px;
  color: #efc79b;
  font-size: 18px;
  font-weight: 700;
}

.edit-icon {
  color: #efc79b;
  font-size: 30px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 0 16px;
  overflow: hidden;
  border: 1px solid rgba(239, 199, 155, 0.24);
  border-radius: 18px;
  background: linear-gradient(90deg, rgba(20, 30, 48, 0.95), rgba(34, 39, 50, 0.92));
}

.stat-item {
  padding: 18px 10px 20px;
  text-align: center;
}

.stat-item + .stat-item {
  border-left: 1px solid rgba(239, 199, 155, 0.12);
}

.stat-label {
  color: rgba(247, 210, 171, 0.78);
  font-size: 18px;
  font-weight: 600;
}

.stat-value {
  margin-top: 10px;
  color: #fff4e7;
  font-size: 26px;
  font-weight: 800;
}

.vip-banner {
  margin: 18px 16px 0;
  padding: 28px 28px 30px;
  border: 1px solid rgba(239, 199, 155, 0.24);
  border-radius: 22px;
  background:
    linear-gradient(90deg, rgba(15, 20, 31, 0.94), rgba(44, 40, 35, 0.88)),
    url('/img/neww/user-bg.png') no-repeat right center / cover;
  color: #f2c28f;
}

.vip-title {
  color: #ffd39f;
  font-size: 34px;
  font-weight: 800;
  line-height: 1.18;
}

.vip-desc {
  margin-top: 6px;
  color: rgba(255, 223, 190, 0.92);
  font-size: 22px;
  font-weight: 700;
  line-height: 1.25;
}

.menu-panel {
  margin: 18px 16px;
  overflow: hidden;
  border-radius: 22px;
  border: 1px solid rgba(239, 199, 155, 0.18);
  background: linear-gradient(180deg, #171b23, #101319);
}

.menu-item {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 30px 24px;
  border: none;
  border-bottom: 1px solid rgba(239, 199, 155, 0.1);
  background: transparent;
  color: #f7d2ab;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
  text-align: left;
}

.menu-item__label {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.menu-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  padding: 0 10px;
  border-radius: 999px;
  background: linear-gradient(180deg, #ff6b6b, #e03131);
  color: #fff;
  font-size: 20px;
  font-weight: 800;
  font-style: normal;
  line-height: 1;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item .van-icon {
  color: #efc79b;
  font-size: 32px;
}
</style>
